import React, { createContext, useState } from 'react'
import { Route, HashRouter, Routes } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Home from './Home'
import About from './About'
import Events from './Events'
import Profile from './Profile'
import ContactUs from './ContactUs'
import Particle from '../components/Particle'
import EventList from './EventList'
import ScrollToTopOnLinkChange from '../components/ScrollToTp'
import ViewEvent from '../components/ViewEvent'
// import ScrollToTopOnLinkChange from '../components/ScrollToTp'


export const UserContext = createContext()

export default function Main() {
    const [isAuth, setIsAuth] = useState(false)
    const value = {
        isAuth,
        setIsAuth,
    }
    

    return (
        <>
            <HashRouter>
                <ScrollToTopOnLinkChange />
                <Particle />
                <UserContext.Provider value={value}>
                    <Header />
                    <Routes>
                        <Route index element={<Home />} />
                        <Route path='/about' element={<About />} />
                        <Route path='/events'>
                            <Route index element={<Events />} />
                            <Route path=':type'>
                                <Route index element={<EventList />} />
                                <Route path=':eventName' element={ <ViewEvent /> } />
                            </Route>
                        </Route>
                        <Route path='/view-event' element={<Profile />} />
                        <Route path='/profile' element={<Profile />} />
                        <Route path='/contact-us' element={<ContactUs />} />
                    </Routes>
                    <Footer />
                </UserContext.Provider>
            </HashRouter>
        </>
    )
}

